// extracted by mini-css-extract-plugin
export var container = "styles-module__container___nRddi";
export var form = "styles-module__form___KDfM3";
export var searchInput = "styles-module__searchInput___hFlFP";
export var offsetSpacer = "styles-module__offsetSpacer___lbkjg";
export var searchBackground = "styles-module__searchBackground___njuv1";
export var dropdownContainer = "styles-module__dropdownContainer___ex0kx";
export var submitBtn = "styles-module__submitBtn___lbsSi";